import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles({
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'contain' as const,
  },
});

interface Props {
  alt?: any;
  src?: any;
  width?: number | string;
  height?: number | string;
  maxWidth?: number | string;
  maxHeight?: number | string;
}

const BaseIcon: React.FC<Props> = ({ alt = '', src, width = 50, height = undefined, maxWidth, maxHeight }: Props) => {
  const classes = useStyles();

  return (
    <div
      style={{
        width,
        height,
        maxWidth,
        maxHeight,
      }}
    >
      <img src={src} className={classes.img} alt={alt} />
    </div>
  );
};

export default BaseIcon;
